import {
  WM_CHANGE_SECTION,
  WM_CHANGE_MENU_SECTION,
  WM_CHANGE_WORKSHEET,
  WM_CHANGE_SLIDER_VISIBILITY,
  WM_INPUT_CHANGED,
  WM_INSERT_SPANISH,
  WM_UPDATE_CURSOR_POSITION,
  WM_TEACHING_TIPS_MODAL_VISIBLE,
  WM_RESET_INPUT_MAP
} from './action-types';

export function changeSection(sectionId) {
  return {
    type: WM_CHANGE_SECTION,
    sectionId
  };
}
export function changeMenuSection(menuSectionId) {
  return {
    type: WM_CHANGE_MENU_SECTION,
    menuSectionId
  };
}

export function changeWorksheet(worksheetId) {
  return {
    type: WM_CHANGE_WORKSHEET,
    worksheetId
  };
}

export function changeSliderVisibility(show) {
  return {
    type: WM_CHANGE_SLIDER_VISIBILITY,
    show
  };
}

export function updateWorksheetInput(worksheetId, currentWorksheetInput) {
  return {
    type: WM_INPUT_CHANGED,
    worksheetId,
    currentWorksheetInput
  };
}

export function insertSpanish(specialChar) {
  return {
    type: WM_INSERT_SPANISH,
    specialChar: specialChar
  };
}

export function updateCursorPosition(inputIndex, cursorPosition) {
  return {
    type: WM_UPDATE_CURSOR_POSITION,
    inputIndex: inputIndex,
    cursorPosition: cursorPosition
  };
}

export function updateModalVisibility(visible) {
  return {
    type: WM_TEACHING_TIPS_MODAL_VISIBLE,
    visible: visible
  };
}
export function resetInputMap() {
  return {
    type: WM_RESET_INPUT_MAP
  };
}
